import React from 'react';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import { setActiveFilterIdAction } from '../../modules/common/cateModule'

const CateFilterBlock = styled.div``;

/**
 * Category Filter Component 
 * useEffect 와 dispatch 사용하면서 무한루트 이슈가 있어서 
 * 직접 redux 참조 처리 하도록 수정 
 * @param {*} param0 
 */
const CateFilter = ({ filterItem }) => {

    const dispatch = useDispatch();

    const { redActiveFilterIds } = useSelector(
        ({ cateItemsReducer }) => ({
            redActiveFilterIds: cateItemsReducer.activeFilterIds,
        })
    );

    if (filterItem === null || filterItem === undefined) {
        return <CateFilterBlock />
    }

    // Filter Active 상태 확인
    const checkActive = (filterid) => {
        return (redActiveFilterIds.indexOf(filterid) !== -1);
    }

    // 전체 선택 상태인지 확인 
    const isAllChecked = () => {
        let filterIdList = filterItem.filter_list.reduce((resultObj, curObj, idx) => {
            resultObj.push((curObj.filter1_id * 100) + curObj.filter2_id);
            return resultObj;
        }, [])

        let activeFilter = redActiveFilterIds.filter(x => filterIdList.includes(x));

        return (activeFilter.length === filterItem.filter_list.length);
    }

    // Filter Check 처리 
    const handleFilterClick = (filterid) => {

        let filterIdList = filterItem.filter_list.reduce((resultObj, curObj, idx) => {
            resultObj.push((curObj.filter1_id * 100) + curObj.filter2_id);
            return resultObj;
        }, [])

        let activeFilter = redActiveFilterIds.filter(x => filterIdList.includes(x));

        // Check 처리 된 항목의 경우 삭제 하여 비체크 처리 
        if (checkActive(filterid) && activeFilter.length > 1) {
            // 1개만 남았을 경우에는 반응하지 않음 
            if (activeFilter.length <= 1) {
                return
            }
            const searchIdx = redActiveFilterIds.indexOf(filterid);
            redActiveFilterIds.splice(searchIdx, 1);
        } else {
            // 추가 
            redActiveFilterIds.push(filterid)
        }
        dispatch(setActiveFilterIdAction(redActiveFilterIds));
    }

    // 전체 선택한 경우 
    const handleAllCheckClick = () => {

        let filterIdList = filterItem.filter_list.reduce((resultObj, curObj, idx) => {
            resultObj.push((curObj.filter1_id * 100) + curObj.filter2_id);
            // console.log("resultObj : " + JSON.stringify(resultObj));
            return resultObj;
        }, [])

        let activeFilter = redActiveFilterIds.filter(x => filterIdList.includes(x));

        // 전체 선택된 상태의 경우 반응하지 않음
        if (activeFilter.length !== filterItem.filter_list.length) {
            // 중복 제거 후 Redux 에 저장 
            let uniqueCateIds = [...new Set(redActiveFilterIds.concat(filterIdList))];
            dispatch(setActiveFilterIdAction(uniqueCateIds));
        }
    }

    return (
        <CateFilterBlock>
            <div className="tf-item clearfix">
                <span className="tf-title">{filterItem.filter_name}</span>
                <ul className="tf-list clearfix">
                    <li onClick={() => { handleAllCheckClick() }}>
                        <span className={"tag_s-item" + (isAllChecked() ? " active" : "")} data-tag="전체">
                            전체
                            <button type="button" className="tag_s-delete"></button>
                        </span>
                    </li>
                    {
                        (
                            filterItem.filter_list.map((subFilter) => {
                                const filterid = (subFilter.filter1_id * 100) + subFilter.filter2_id;
                                return (
                                    <li key={filterid} onClick={() => { handleFilterClick(filterid) }}>
                                        <span className={"tag_s-item item-tag" + (checkActive(filterid) ? " active" : "")}>
                                            {subFilter.filter_name}
                                            <button type="button" className="tag_s-delete"></button>
                                        </span>
                                    </li>
                                );
                            })
                        )
                    }
                </ul>
            </div>
        </CateFilterBlock>
    );
};

export default CateFilter;